import {FormikFieldConfig, FormikFieldTypes, ValidationErrorType} from 'palipali-panel-common-web';
import {useTranslation} from 'react-i18next';
import * as Yup from 'yup';

export const vehicleInsuranceFormConfig = (): FormikFieldConfig[] => {
    const {t} = useTranslation();
    return [
        {
            name: 'number',
            label: t('vehicles.vehicleOperation.insurance.form.number.label'),
            validation: Yup.string()
                .max(255)
                .required(`${t(ValidationErrorType.IS_REQUIRED)}`),
            type: FormikFieldTypes.TEXT,
        },
        {
            name: 'until',
            label: t('vehicles.vehicleOperation.insurance.form.until.label'),
            validation: Yup.date()
                .required(`${t(ValidationErrorType.IS_REQUIRED)}`)
                .min(new Date(), `${t('formValidation.errors.isProcessAtLaterThanNow')}`),
            startFromTomorrow: true,
            className: 'vehicle-insurance-form-until-form-control',
            type: FormikFieldTypes.DATE,
            dateFormat: 'dd.MM.yyyy',
        },
        {
            name: 'files',
            label: t('vehicles.vehicleOperation.insurance.form.documentPhoto.label'),
            validation: Yup.object()
                .shape({
                    name: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                    fileKey: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                    url: Yup.string().required(`${t(ValidationErrorType.IS_REQUIRED)}`),
                })
                .required(`${t(ValidationErrorType.IS_REQUIRED)}`),
            acceptedFileTypes: 'image/jpeg, image/png, application/pdf',
            multipleFiles: false,
            className: 'vehicles-view-vehicle-insurance-form-insurance-photo',
            placeholder: `${t('vehicles.vehicleOperation.inspection.form.documentPhoto.placeholderBack')}`,
            type: FormikFieldTypes.FILE,
        },
    ];
};
